import { UnidadeModel } from './../../model/endereco/unidade.model';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class UnidadeService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  getPageUnidade(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/page-unidades?page=${page}&size=${size}`, this.httpOptions);
  }

  getUnidades(): Observable<UnidadeModel[]> {
    return this.httpClient.get<UnidadeModel[]>(this.apiURL + "/list-unidades", this.httpOptions);
  }

  adicionarUnidade(unidade: UnidadeModel): Observable<UnidadeModel> {
    return this.httpClient.post<UnidadeModel>(this.apiURL + "/adicionar-unidade", unidade, this.httpOptions);
  }

  editarUnidade(unidade: UnidadeModel): Observable<UnidadeModel> {
    return this.httpClient.put<UnidadeModel>(this.apiURL + "/editar-unidade", unidade, this.httpOptions);
  }

  apagarUnidade(unidadeId: Number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + `/excluir-unidade/${unidadeId}`,  { headers, responseType: 'text'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/endereco/unidade.service.ts